import { styled } from "@mui/material"
import {
  Box,
  Button,
  ThemeProvider,
  Typography,
  createTheme,
} from "@mui/material"

export const MetricHeaderWrapper = styled(Box)({
  width: "100%",
  height: "10vh",
  backgroundColor: "#F8F9FA",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "flex-start",
  //padding: "15px 30px",
})

export const MetricHeaderLeft = styled(Box)({
  // border: "1px solid red",
  margin: "0",
})

export const MetricGoalsHeaderMid = styled(Box)({
  height: "100%",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  // border: "1px solid red",
  marginLeft: "100px",
})

export const MetricHeaderRight = styled(Box)({})

export const AssignButton = styled(Button)`
  width: 105px;
  height: 40px;
  background-color: #3366d6;
  color: white;
  text-transform: capitalize;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  fontsize: "inherit";
`
export const LoadSavedVersion = styled(Button)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "&:hover": {
    backgroundColor: "#1C56CE",
    color: "#fff",
  },
  width: "fit-content",
  backgroundColor: "#fff",
  color: "#3c77ef",
  textTransform: "capitalize",
  fontSize: "14px",
  padding: "10px 17px",
  border: "1px solid #3c77ef",
})

export const customTheme = createTheme({
  typography: {
    fontFamily: ["Poppins"].join(","),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          width: "408px",
          height: "40px",
          display: "flex",
          backgroundColor: "#FFFFFF",
          justifyContent: "space-between",
          border: "1px solid #BEBEBE",
          borderRadius: "4px",
          opacity: 1,
          marginRight: "18px",
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        root: {
          marginTop: "6px",
          background: " 0% 0% no-repeat padding-box",
          boxShadow: " 0px 2px 8px #00000022",
          borderRadius: "4px",
          Opacity: 1,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          width: "408px",
        },
      },
    },
  },
})
